document.addEventListener("DOMContentLoaded", function () {
  const toc = document.querySelector(".kc-toc");
  const title = document.querySelector(".kc-toc-title");
  const links = Array.from(document.querySelectorAll(".kc-toc-list a"));

  if (!toc || !title || !links.length) return;

  const sections = links
    .map(function (link) {
      return document.querySelector(link.getAttribute("href"));
    })
    .filter(Boolean);

  if (!sections.length) return;

  const progress = document.createElement("div");
  progress.className = "kc-toc-progress";
  progress.innerHTML =
    '<div class="kc-toc-progress-label">' +
      '<span>Progress</span>' +
      '<span class="kc-toc-progress-percent">0%</span>' +
    '</div>' +
    '<div class="kc-toc-progress-track">' +
      '<div class="kc-toc-progress-fill"></div>' +
    '</div>';

  title.insertAdjacentElement("afterend", progress);

  const fill = progress.querySelector(".kc-toc-progress-fill");
  const percent = progress.querySelector(".kc-toc-progress-percent");

  function updateProgress() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progressValue = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;

    fill.style.width = progressValue + "%";
    percent.textContent = progressValue + "%";

    let activeSection = sections[0];

    sections.forEach(function (section) {
      if (section.getBoundingClientRect().top <= 180) {
        activeSection = section;
      }
    });

    links.forEach(function (link) {
      const targetId = link.getAttribute("href").replace("#", "");
      const targetSection = document.getElementById(targetId);

      link.classList.remove("is-active", "is-read");

      if (targetSection === activeSection) {
        link.classList.add("is-active");
      } else if (sections.indexOf(targetSection) < sections.indexOf(activeSection)) {
        link.classList.add("is-read");
      }
    });
  }

  updateProgress();
  window.addEventListener("scroll", updateProgress, { passive: true });
});